import { combineReducers } from '@reduxjs/toolkit';
import { reducer as toastrReducer } from 'react-redux-toastr';

import homeDataSlice from '../../views/app-views/home/reducer/homeDataSlice';

const rootReducer = combineReducers({
  toastr: toastrReducer,
  homeData: homeDataSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
